import { z } from "zod"

export const ProjectSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional().nullable(),
  api_key: z.string(),
  slug: z.string(),
  postmark_api_token: z.string().optional().nullable(),
  sender_name: z.string().optional().nullable(),
  sender_email: z.string().email(),
  apns_team_id: z.string().optional().nullable(),
  apns_key_id: z.string().optional().nullable(),
  apns_bundle_id: z.string().optional().nullable(),
  is_archived: z.boolean(),
})

export type Project = z.infer<typeof ProjectSchema>
